import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { toString } from 'lodash';
import { isProduction } from 'src/utils/environment';
import { queryKeys } from 'src/utils/queryKeys';

export const useGetEnvironment = () =>
  useQuery({
    queryKey: queryKeys.environment.all(),
    queryFn: fetchEnvironment,
    staleTime: Infinity,
  });

const fetchEnvironment = async () => {
  if (!isProduction()) {
    const response = await axios.get(toString(process.env.ENVIRONMENT));

    window.environment = response.data;
  }

  return window.environment;
};
